'use strict';

/**
 * Placeholder Object
 * @param elContainer
 * @constructor
 */
var MemoPlaceholder = function(elContainer) {
    var _ = this;
    _.elContainer = elContainer || document.querySelector('body');

    /**
     * Init
     */
    const init = function() {
        const nlInputs = _.elContainer.querySelectorAll('.input');

        if (nlInputs.length > 0) {
            nlInputs.forEach(function(el) {
                const elCurrentContainer = el;
                const elCurrentInput = elCurrentContainer.querySelector('input,textarea');

                if (elCurrentInput) {
                    elCurrentInput.addEventListener('animationstart', function(target) {
                        switch (target.animationName) {
                            case 'onAutoFillStart':
                                elCurrentContainer.classList.add('input--placeholder', 'input--is-filled-out');
                                break;
                            case 'onAutoFillCancel':
                                break;
                        }
                    }, false);

                    if (elCurrentInput.hasAttribute('placeholder') || elCurrentInput.value !== '') {
                        elCurrentContainer.classList.add('input--placeholder', 'input--is-filled-out');
                    } else {
                        elCurrentContainer.classList.add('input--is-empty');
                    }

                    elCurrentInput.addEventListener('focus', function() {
                        elCurrentContainer.classList.add('input--has-focus');
                    });

                    elCurrentInput.addEventListener('focusout', function() {
                        elCurrentContainer.classList.remove('input--has-focus');

                        if (elCurrentInput.required && elCurrentInput.value === '') {
                            elCurrentContainer.classList.add('input--is-invalid');
                        }
                    });

                    elCurrentInput.addEventListener('change', function() {
                        elCurrentContainer.classList.remove('input--is-invalid');
                        elCurrentContainer.classList.remove('input--is-valid');

                        if (
                            elCurrentInput.value === ''
                            && (elCurrentInput.getAttribute('placeholder') === null
                                || elCurrentInput.getAttribute('placeholder') === '')
                        ) {
                            elCurrentContainer.classList.add('input--is-empty');
                            elCurrentContainer.classList.remove('input--is-filled-out');
                        } else {
                            elCurrentContainer.classList.remove('input--is-empty');
                            elCurrentContainer.classList.add('input--is-filled-out');

                            if (elCurrentInput.checkValidity()) {
                                elCurrentContainer.classList.remove('input--is-invalid');
                                elCurrentContainer.classList.add('input--is-valid');
                            } else {
                                elCurrentContainer.classList.add('input--is-invalid');
                                elCurrentContainer.classList.remove('input--is-valid');
                            }
                        }
                    });
                }
            });
        }
    };

    init();
};

export default MemoPlaceholder;
